export default {
  name: 'ChartThemeSelector',
  props: {
    theme: {
      type: Object
    }
  },
  computed: {
    colors() {
      const {
        background,
        left,
        right
      } = this.theme ?? {};
      return Object.entries({
        background,
        left,
        right
      });
    }
  }
};